/**
 * Membership template: events tabs + Splide carousels (upcoming / past).
 */
(function () {
	'use strict';

	function mountEventsSplide(rootSelector) {
		var el = document.querySelector(rootSelector);
		if (!el || typeof window.Splide === 'undefined') {
			return null;
		}
		var slides = el.querySelectorAll('.splide__slide');
		if (!slides.length) {
			return null;
		}
		var splide = new window.Splide(el, {
			type: 'slide',
			perPage: 3,
			perMove: 1,
			gap: '20px',
			arrows: true,
			pagination: false,
			drag: true,
			speed: 600,
			breakpoints: {
				1199: {
					perPage: 2,
					gap: '18px',
				},
				767: {
					perPage: 1,
					gap: '16px',
				},
				480: {
					gap: '12px',
				},
			},
		});
		splide.mount();
		return splide;
	}

	function initMembershipEvents() {
		var splideUpcoming = mountEventsSplide('#membership-events-upcoming');
		var splidePast = mountEventsSplide('#membership-events-past');

		var tabs = document.querySelectorAll('.journal-sec .journal-tab .tab');
		var contents = document.querySelectorAll('.journal-sec .journal-tab-content .tab-content');
		if (!tabs.length || !contents.length) {
			return;
		}

		tabs.forEach(function (tab, index) {
			tab.addEventListener('click', function () {
				tabs.forEach(function (t) {
					t.classList.remove('active');
					t.setAttribute('aria-selected', 'false');
				});
				tab.classList.add('active');
				tab.setAttribute('aria-selected', 'true');

				contents.forEach(function (content) {
					content.classList.remove('active');
				});
				if (contents[index]) {
					contents[index].classList.add('active');
				}

				if (index === 0 && splideUpcoming) {
					splideUpcoming.refresh();
				}
				if (index === 1 && splidePast) {
					splidePast.refresh();
				}
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initMembershipEvents);
	} else {
		initMembershipEvents();
	}
})();
